import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import LoadMore from '../Common/LoadMore';

const PendingSessionList = observer(class PendingSessionList extends React.Component {
  viewMessage(messageThreadSid) {
    const _this = this;

    this.props.parent.setState({
      messageThreadSid
    }, function(){
      toggleDrawer(null, _this.props.parent, 'MessageThread');
    })
  }

  render() {
    const { translation } = this.props;
    const { ScheduleStore, SessionStore } = this.props.store;
    const { pendingNext, pendingSessions } = ScheduleStore;

    if(SessionStore.backgroundLoadingCalls.indexOf('GetPendingSessions') < 0 && ScheduleStore.pendingSessions.length > 0) {
      return (
        <div>
          <table>
            <thead>
              <tr>
                <th id="heading-student" className="subtitle" scope="col">
                  {translation.student}
                </th>
                <th id="heading-exam" className="subtitle" scope="col">
                  {translation.exam}
                </th>
                {this.props.type === 'pending' &&
                  <th id="heading-accepted" className="subtitle" scope="col">
                    {translation.accepted_date}
                  </th>
                }
                <th id="heading-date" className="subtitle" scope="col">
                  {translation[`date_${this.props.type}`]}
                </th>
                <th id="heading-view" className="subtitle" scope="col">
                  {translation.view}
                </th>
              </tr>
            </thead>
            <tbody>
              {ScheduleStore.pendingSessions.map(
                (session, i) =>
                <tr key={i}>
                  <td aria-labelledby="heading-student">
                    {session.candidate.firstName} {session.candidate.lastName}
                  </td>
                  <td aria-labelledby="heading-exam">
                    {session.exam.title}
                  </td>
                  {this.props.type === 'pending' &&
                    <td aria-labelledby="heading-accepted">
                      {moment(session.request.confirmedDate).local().tz(moment.tz.guess()).format('M/D/YYYY h:mma z')}
                    </td>
                  }
                  <td aria-labelledby="heading-date">
                    {this.props.type === 'request' &&
                      moment(session.request.createdDate).local().tz(moment.tz.guess()).format('M/D/YYYY h:mma z')
                    }

                    {this.props.type === 'pending' &&
                      moment(session.request.confirmedDateExpiration).local().tz(moment.tz.guess()).format('M/D/YYYY h:mma z')
                    }
                  </td>
                  <td className="actions" aria-labelledby="heading-view">
                    <button
                      className="btn--outline"
                      onClick={() => this.viewMessage(session.request.messageThreadSid)}
                    >
                      {translation.view_message}
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {pendingNext &&
            <LoadMore
              url={pendingNext}
              group={pendingSessions}
              text="Load more pending sessions"
              {...this.props}
            />
          }
        </div>
      );
    } else if(SessionStore.backgroundLoadingCalls.indexOf('GetPendingSessions') >= 0) {
      return <span className="loader-bar">Loading…</span>
    } else {
      return <span className="no-results">{translation[`no_results_${this.props.type}`]}</span>
    }
  }
})

export default translate('PendingSessionList')(PendingSessionList);


// WEBPACK FOOTER //
// ./src/app/components/Sessions/PendingSessionList.js